import { Marker, Popup } from "mapbox-gl";
import { useCallback, useEffect } from "react";

import { Evented, MapEventType } from "./types";

export const useMapboxEvented = (
  evented: Evented | Marker | Popup | null | undefined,
  type: MapEventType,
  fn?: Function
) => {
  const onHandler = useCallback(
    (...args: any[]) => {
      if (fn) {
        fn(...args);
      }
    },
    [fn]
  );

  useEffect(() => {
    const listener = (...args: any[]) => {
      if (typeof onHandler === "function") {
        onHandler(...args);
      }
    };
    // Subscribe to the evented
    if (evented && evented.on) {
      evented.on(type, listener);
    }
    // Unsub
    return () => {
      if (evented && evented.off) {
        evented.off(type, listener);
      }
    };
  }, [evented, onHandler, type]);
};

export default useMapboxEvented;
